// Main entry — the production View. (No Container: RailHeader is a pure
// View.) Sim wrappers live under ./sim and are never imported here.
export { RailHeader } from "./RailHeader";
export type { RailHeaderProps } from "./RailHeader";
